import { MutationOptions, useMutation } from 'react-query';

import { deleteContactsById } from '@app/store/transport-layer/document/address-book/contacts';

const useDeleteContactsById = (options?: MutationOptions<unknown, Error, string>) => {
  return useMutation<unknown, Error, string>(deleteContactsById, options);
};

export default useDeleteContactsById;
